"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Media",
  "ui:layout": "fieldset",
  "ui:options": {
    "draggable": true
  },
  "ui:sidebar": {
    "query": {
      "models": "media",
      "mediaType": ["image", "video", "audio", "vimeo", "youtube"]
    }
  },
  "ui:buttons": [{
    "type": "sidebar",
    "icon": "search",
    "label": "Finn media"
  }, {
    "type": "upload",
    "label": "Last opp"
  }],
  "items": {
    "ui:layout": "module",
    "ui:options": {
      "editable": true,
      "hideable": true
    },
    "ui:settings": ["mediaSize", "mediaFormat"],
    "ui:fieldset": ["content", "media"],
    "content": {
      "ui:title": "Innhold",
      "ui:options": {
        "grid": true,
        "padding": 2,
        "spacing": 2
      },
      "ui:fieldset": ["headline", "description", "creditLine"],
      "description": {
        "ui:widget": "textarea"
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;